export enum CollapseTransitions {
  Detailed = 'detailed',
  Collapsed = 'collapsed',
  Consolidated = 'consolidated'
}
